$(document).ready(function($){
  // Create the dropdown base
  $('<select class="uniform" />').appendTo('.side-navigation');

  // Create default option 'Go to...'
  $('<option />', {
     'selected': 'selected',
     'value'   : '',
     'text'    : '-- select --'
  }).appendTo('.side-navigation select');

  // Populate dropdown with menu items
  $('.side-navigation a').each(function() {
   var el = $(this);
   $('<option />', {
       'value'   : el.attr('href'),
       'text'    : el.text()
   }).appendTo('.side-navigation select');
  });

  $('.side-navigation select').change(function() {
    $('.side-navigation select option:selected').val();
    // window.location.hash = $(this).val();
    document.querySelector($(this).val()).scrollIntoView({ 
      behavior: 'smooth' 
    });
  });  

  // uniform the select bars only
  $('.uniform').uniform();
});